export default [
  {
    name: 'refundApply',//申请退款
    path: '/refundApply',
    meta: {
      title: '申请退款',
      showTab: false,
    },
    component: () => import("@/pages/refund/refundApply.vue"),
  },
  {
    name: 'refundDetail',//退款详情
    path: '/refundDetail',
    meta: {
      title: '退款详情',
      showTab: false,
    },
    component: () => import("@/pages/refund/refundDetail.vue"),
  },

]